<script lang="ts">
    import { untrack } from 'svelte';

    interface Props {
        variationId: string;
        bestVariationBenefit?: string;
        rule?: string;
    }

    /**
 *
 *
 *
 *
 */
    const { variationId, bestVariationBenefit, rule }: Props = $props();

    let lastVariationId = $state(untrack(() => variationId));
    let useVariationIdBenefit = $state(false);

    $effect(() => {
        if (variationId !== lastVariationId) {
            useVariationIdBenefit = true;
            lastVariationId = variationId;
        }
    });
</script>

{#key variationId}
    {#if useVariationIdBenefit}
        <ft9-benefit-tag-v1
            id={`${variationId}-benefit-tag`}
            current-context-dreson={rule}
            team="reptile"
            feature="tilelist"
            variation-id={variationId}
        ></ft9-benefit-tag-v1>
    {:else if bestVariationBenefit}
        <ft9-benefit-tag-v1
            id={`${variationId}-benefit-tag`}
            current-context-dreson={rule}
            team="reptile"
            feature="tilelist"
            data={bestVariationBenefit}
        ></ft9-benefit-tag-v1>
    {/if}
{/key}
